import { FC, useMemo, MouseEvent, useCallback } from 'react'
import * as styles from 'components/features/socialFeed/SocialProfileEnsure/SocialProfileEnsure.styl'
import { useShallowSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { memberFeedInfoSelector } from 'selectors/feedSelectors'
import { changeSocialProfileStepActionCreator } from 'actions/feedActions'
import { WithComposeId } from 'interfaces/feed'
import debounce from 'lodash/debounce'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'

type MouseEventHandler = (event: MouseEvent<HTMLDivElement>) => void

type SocialProfileEnsureProps =
  & WithComposeId
  & {
    stopPropagation?: boolean
  }

export const SocialProfileEnsure: FC<SocialProfileEnsureProps> = (props) => {
  const { children, stopPropagation, composeId } = props

  const isAuthenticated = useShallowSelector(isAuthenticatedSelector)
  const feedMember = useShallowSelector(memberFeedInfoSelector)
  const hasUsername = useMemo(() => {
    return Boolean(feedMember ? feedMember.username : '')
  }, [feedMember])

  const dispatch = useStoreDispatch()

  // TODO: @mitasovr: prevent compose expand in case when social profile not exists yet
  const handleClick = useCallback<MouseEventHandler>(debounce<MouseEventHandler>((event) => {
    if (!isAuthenticated || hasUsername) {
      return
    }
    if (stopPropagation) {
      event.stopPropagation()
    }

    dispatch(changeSocialProfileStepActionCreator('form', composeId))
  }, 10), [hasUsername, stopPropagation, isAuthenticated])

  return (
    <div
      className={ styles.socialProfileEnsure }
      onClickCapture={ handleClick }
    >
      { children }
    </div>
  )
}
